import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { State, Selector, StateContext, Action } from '@ngxs/store';
import { LoadingDashboardCompleted, LoadingDashboardStarted } from './grafana-dashboard-viewer-behaviour.actions';

export interface GrafanaDashboardViewerBehaviourStateModel {
   [instanceId: string]: GrafanaDashboardViewerBehaviourInstance;
}

export interface GrafanaDashboardViewerBehaviourInstance {
   isLoading: boolean;
}

export function DefaultGrafanaDashboardViewerBehaviourInstance(): GrafanaDashboardViewerBehaviourInstance {
   return {
      isLoading: false,
   };
}

@State<GrafanaDashboardViewerBehaviourStateModel>({
   name: 'grafanaDashboardViewerBehaviourState',
   defaults: {},
})
@Injectable()
export class GrafanaDashboardViewerBehaviourState {
   private static getSpecificBehaviourStateOrDefault(
      state: GrafanaDashboardViewerBehaviourStateModel,
      brickInstanceId: string
   ): GrafanaDashboardViewerBehaviourInstance {
      return state[brickInstanceId] ?? DefaultGrafanaDashboardViewerBehaviourInstance();
   }

   @Selector([GrafanaDashboardViewerBehaviourState])
   public static getIsLoading(state: GrafanaDashboardViewerBehaviourStateModel) {
      return (brickInstanceId: string) => {
         return this.getSpecificBehaviourStateOrDefault(state, brickInstanceId).isLoading;
      };
   }

   @Action(LoadingDashboardStarted)
   @ImmutableContext()
   public loadingDashboardStarted(ctx: StateContext<GrafanaDashboardViewerBehaviourStateModel>, action: LoadingDashboardStarted) {
      ctx.setState((state: GrafanaDashboardViewerBehaviourStateModel) => {
         const behavior = GrafanaDashboardViewerBehaviourState.getSpecificBehaviourStateOrDefault(state, action.brickInstanceId);
         behavior.isLoading = true;
         state[action.brickInstanceId] = behavior;
         return state;
      });
   }

   @Action(LoadingDashboardCompleted)
   @ImmutableContext()
   public loadingDashboardFinished(ctx: StateContext<GrafanaDashboardViewerBehaviourStateModel>, action: LoadingDashboardCompleted) {
      ctx.setState((state: GrafanaDashboardViewerBehaviourStateModel) => {
         const behavior = GrafanaDashboardViewerBehaviourState.getSpecificBehaviourStateOrDefault(state, action.brickInstanceId);
         behavior.isLoading = false;
         state[action.brickInstanceId] = behavior;
         return state;
      });
   }
}
